module.exports = __webpack_public_path__ + "sharp-sans-bold-c343c52da65f1f57d80ee113237e463a.bundle.woff2";